module.exports = __webpack_public_path__ + "img/icon-installment1.bc90a3dd.png";